import {FormFilesType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'

const teamPhotoField: FormFilesType = {
	id: 0,
	parent_id: 0,
	channel: 'files',
	filesize: 2,
	filetypes: ['.jpg', '.png', '.jpeg'],
	multiple: false,
	label: copy?.teamphoto?.label || 'Teamfoto',
	name: 'teamfoto',
	placeholder: copy?.teamphoto?.placeholder || 'Upload teamfoto',
	required: false,
	value: null
}

export default teamPhotoField
